import { render, staticRenderFns } from "./travelMedicalCare.vue?vue&type=template&id=279fb207"
import script from "./travelMedicalCare.vue?vue&type=script&lang=js"
export * from "./travelMedicalCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports